/*
 * This file is part of the Convergence API Server.
 *
 * (c) Convergence <https://convergence.finance/>
 */

import PropTypes from "prop-types";
import React from "react";
import DealsListingContainer from "./DealsListingContainer";
import { AuthorizationService } from "../../../../service/AuthorizationService";
import fakeDeals from "./fakeHDDList.json";

type Props = {
    authorizationService: AuthorizationService;
    first?;
    sort?;
    filters?;
    keyword?;
    pagedListFilterBar?;
    updateState?;
};

type State = {
    hasPermission: boolean;
};
class FakeDealsListing extends React.Component<Props, State> {
    static propTypes = {
        user: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            hasPermission: null
        };
    }

    render() {
        const { authorizationService } = this.props;

        return (
            <DealsListingContainer
                data={{}}
                networkStatus={7}
                loading={false}
                deals={fakeDeals.data.deals.edges}
                hasNextPage={false}
                fetchMore={() => {}}
                refetch={() => {}}
                dealType={"active"}
                pagedListFilterBar={this.props.pagedListFilterBar}
                authorizationService={authorizationService}
                keyword={this.props.keyword}
                sort={this.props.sort}
                updateState={this.props.updateState}
            />
        );
    }
}

export default FakeDealsListing;
